<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
  @if (data.innerHTML) {
    <div [innerHTML]="data.message"></div>
  }
  @if (!data.innerHTML) {
    <p> {{ data.message }}</p>
  }
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" [mat-dialog-close]="true">{{ 'dialog.btnYes' | translate }}</button>&nbsp;
  <button mat-raised-button color="secondary" [mat-dialog-close]="false">{{ 'dialog.btnNo' | translate }}</button>
</div>
